import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IProduto, IProdutoVariacao } from '@app/modules/produto/model';
import { ProdutoService } from '@app/modules/produto/services';
import { ProdutosSettingsService } from '@app/modules/produto/services/produto-service/produto-settings.service';
import {
  IVariacao,
  IVariacaoItem
} from '@app/modules/variacao-produtos/model/variacao.model';
import { VariacaoItensService } from '@app/modules/variacao-produtos/services/variacao-itens.service';
import { VariacaoService } from '@app/modules/variacao-produtos/services/variacao.service';
import {
  ConfirmDialogComponent,
  DialogSearchComponent
} from '@app/shared/components';
import { Utils } from '@app/shared/helpers/utils';
import { TokenService } from 'viggo-sistemas-core-web';

@Component({
  selector: 'app-form-produto-variacoes',
  templateUrl: './app-form-produto-variacoes.component.html',
  styleUrls: ['./app-form-produto-variacoes.component.scss'],
  providers: [
    VariacaoItensService,
    VariacaoService,
    ProdutoService,
    ProdutosSettingsService
  ]
})
export class AppFormProdutoVariacoesComponent {
  @Input() entity: IProduto;
  @Input() descricao: string = '';
  @Input() quantidade: number = 0;
  @Input() valor_minimo: number = 0;
  @Input() codigo_barra: string = '';
  @Input() updateRowsVariacao = false;

  @Output() changedProducts = new EventEmitter<boolean>();
  @Output() changedVariacoes = new EventEmitter<boolean>();
  @Output() clearVariacoes = new EventEmitter<void>();

  settings = { variacoes: [] };

  changedVariacao = false;
  variacaoControl: UntypedFormControl;
  variacoes: UntypedFormControl;
  produtos_variacao: UntypedFormControl;

  constructor(
    public matDialog: MatDialog,
    public matSnackBar: MatSnackBar,
    protected entityService: ProdutoService,
    protected produtoSettingsService: ProdutosSettingsService,
    protected varicaoService: VariacaoService,
    protected tokenService: TokenService,
    protected variacaoItensService: VariacaoItensService
  ) {}

  ngOnInit() {
    this.variacaoControl = new UntypedFormControl(null);

    this.settings.variacoes = this.entity.id
      ? this.entity.settings_variacoes
      : [];

    this.variacoes = new UntypedFormControl(
      this.entity.id ? this.entity.settings_variacoes : [],
      [Validators.minLength(1)]
    );

    this.produtos_variacao = new UntypedFormControl(
      this.entity.variacoes || [],
      [Validators.minLength(1)]
    );

    this.produtos_variacao.statusChanges.subscribe(status => {
      if (status === 'VALID') {
        this.changedProducts.emit(true);
      } else {
        this.changedProducts.emit(false);
      }
    });
  }

  /**
   * Dialog de filtros para seleção de variação e itens de uma variação
   */
  openFilterVariacoes() {
    var columns = [
      {
        header_name: 'Descrição',
        active: true,
        removable: false,
        field: 'descricao',
        flex: 1,
        sortable: false,
        field_sortable: 'descricao'
      }
    ];
    var itensColumns = [
      {
        header_name: 'Descrição',
        active: true,
        removable: false,
        field: 'descricao',
        flex: 1,
        sortable: false,
        field_sortable: 'descricao'
      }
    ];
    var fields = [
      {
        label: 'Descrição da variação',
        control: new UntypedFormControl(''),
        class: 'field w-column col-6 md:col-12',
        display_search: 'descricao'
      },
      {
        label: 'Descrição dos itens da variação',
        control: new UntypedFormControl(''),
        class: 'field w-column col-6 md:col-12',
        display_search: 'variacao_item.descricao'
      }
    ];
    this.matDialog
      .open(DialogSearchComponent, {
        panelClass: ['custom-container', 'position-relative'],
        height: '700px',
        data: {
          entityService: this.varicaoService,
          entityName: 'variações',
          urlEntity: 'variações',
          columnDefs: columns,
          itensColumnDefs: itensColumns,
          title: 'Buscar variações',
          fields: fields,
          addBtn: true,
          useTableExpanded: true,
          params_path: 'variacao_item.active',
          params: true,
          include: ['itens.variacao'],
          order_by: ['descricao'],
          insertType: 'variacao_produto'
        }
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.adicionarVariacoes(result, false);
        }
      });
  }

  /**
   * Confirma a seleção das variações e gera os produtos variação
   * @param result
   * @param autocomplete
   */
  adicionarVariacoes(result, autocomplete: boolean) {
    var combinacoes_possiveis = 1;
    if (!autocomplete) {
      if (result.entities.length) {
        result.entities.forEach(it => {
          combinacoes_possiveis *= it.itens.length;
        });
      }
      if (result.subEntities.length && result.entities.length == 0) {
        combinacoes_possiveis *= result.subEntities.length;
      }
    }

    this.variacoes.value.forEach(it => {
      combinacoes_possiveis *= it.itens.length;
    });

    if (combinacoes_possiveis >= 500) {
      this.matDialog.open(ConfirmDialogComponent, {
        data: {
          title: 'Aviso!',
          bodyMessage: `Não foi possível prosseguir com a adição das variações, pois existe um limite de combinações possíveis de até 500 e pela seleção foi contabilizado um total de ${combinacoes_possiveis} combinações possíveis.`,
          icon: 'warning',
          icon_color: 'accent',
          singleBtn: true
        },
        width: '400px',
        panelClass: ['custom-container', 'position-relative']
      });
    } else {
      var totalForm = this.variacoes.value.length;
      if (confirm) {
        this.changedVariacao = true;
        if (autocomplete) {
          if (totalForm + 1 > 5) {
            this.matDialog.open(ConfirmDialogComponent, {
              data: {
                title: 'Aviso!',
                bodyMessage:
                  'Não foi possível prosseguir com a adição das variações, pois existe um limite de até 5 variações que podem ser selecionadas.',
                icon: 'warning',
                icon_color: 'accent',
                singleBtn: true
              },
              width: '400px',
              panelClass: ['custom-container', 'position-relative']
            });
            this.variacaoControl.reset();
          } else {
            this.addFromAutoComplete(result);
            // if (this.entity.id) this.confirmarVariacao();
          }
        } else {
          const arrayVariacaoIds = result.entities.map(ent => ent.id);
          const arrayVariacaoItemIds = result.subEntities.map(
            ent => ent.variacao_id
          );
          totalForm += arrayVariacaoIds
            .concat(arrayVariacaoItemIds)
            .filter(
              (id, index) =>
                arrayVariacaoIds.concat(arrayVariacaoItemIds).indexOf(id) ===
                index
            ).length;
          if (totalForm > 5) {
            this.matDialog.open(ConfirmDialogComponent, {
              data: {
                title: 'Aviso!',
                bodyMessage:
                  'Não foi possível prosseguir com a adição das variações, pois existe um limite de até 5 variações que podem ser selecionadas.',
                icon: 'warning',
                icon_color: 'accent',
                singleBtn: true
              },
              width: '400px',
              panelClass: ['custom-container', 'position-relative']
            });
          } else {
            this.addFromDialog(result);
            // if (this.entity.id) this.confirmarVariacao();
          }
        }
      }
    }
  }

  /**
   * Captura o valor vindo do autocomplete de variacoes e insere nas settings
   * e form de variacoes
   * @param result
   * @returns
   */
  addFromAutoComplete(result) {
    if (this.variacoes.value.length) {
      const prevValue = this.variacoes.value;
      const index = prevValue.findIndex(
        x => x.variacao_id === result.variacao.id
      );
      if (index >= 0) {
        const index2 = prevValue[index].itens.findIndex(
          x => x.variacao_item_id === result.id
        );
        if (index2 >= 0) {
          this.variacaoControl.reset();
          return;
        }

        prevValue[index].itens.push({ ...result, variacao_item_id: result.id });
      } else {
        result.variacao.itens = [];
        result.variacao.itens.push({ ...result, variacao_item_id: result.id });
        prevValue.push({ ...result.variacao, variacao_id: result.variacao.id });
        this.variacoes.setValue(prevValue);
      }
    } else {
      this.settings.variacoes.push({
        ...result.variacao,
        variacao_id: result.variacao.id,
        itens: [{ ...result, variacao_item_id: result.id }]
      });
      this.variacoes.setValue(this.settings.variacoes);
    }
    this.variacaoControl.reset();
  }

  /**
   * Captura o valor vindo do dialog de variacoes e insere os valores nas
   * settings e no form de variacoes
   * @param result
   * @returns
   */
  addFromDialog(result) {
    if (result.entities.length) {
      result.entities.forEach(ent => {
        ent.itens.forEach(it => {
          it.variacao_item_id = it.id;
        });
        if (this.variacoes.value.length) {
          this.settings.variacoes = this.variacoes.value;
          const index = this.settings.variacoes.findIndex(
            x => x.variacao_id === ent.id
          );
          if (index >= 0) {
            this.settings.variacoes.splice(index, 1);
            this.settings.variacoes.push({ ...ent, variacao_id: ent.id });
          } else {
            this.settings.variacoes.push({ ...ent, variacao_id: ent.id });
          }
        } else this.settings.variacoes.push({ ...ent, variacao_id: ent.id });
      });
    }
    if (result.subEntities.length) {
      if (this.variacoes.value.length) {
        this.settings.variacoes = this.variacoes.value;
        result.subEntities.forEach(ent => {
          const index = this.settings.variacoes.findIndex(
            x => x.variacao_id === ent.variacao_id
          );
          if (index >= 0) {
            const index2 = this.settings.variacoes[index].itens.findIndex(
              x => x.variacao_item_id === ent.id
            );
            if (index2 >= 0) return;

            this.settings.variacoes[index].itens.push({
              ...ent,
              variacao_item_id: ent.id
            });
          } else {
            ent.variacao.itens = [];
            ent.variacao.itens.push({ ...ent, variacao_item_id: ent.id });
            this.settings.variacoes.push({
              ...ent.variacao,
              variacao_id: ent.variacao.id
            });
          }
        });
      } else {
        result.subEntities.forEach(ent => {
          const index = this.settings.variacoes.findIndex(
            x => x.variacao_id === ent.variacao_id
          );
          if (index >= 0) {
            const index2 = this.settings.variacoes[index].itens.findIndex(
              y => y.variacao_item_id === ent.variacao_item_id
            );
            if (index2 >= 0) return;
            else {
              this.settings.variacoes[index].itens.push({
                ...ent,
                variacao_item_id: ent.id
              });
            }
          } else {
            ent.variacao.itens = [];
            ent.variacao.itens.push({ ...ent, variacao_item_id: ent.id });
            this.settings.variacoes.push({
              ...ent.variacao,
              variacao_id: ent.variacao.id
            });
          }
        });
      }
    }
    this.variacoes.setValue(this.settings.variacoes);
  }

  /**
   * Remove uma variação da lista de variações selecionadas
   * @param variacao
   */
  removerVariacao(variacao: IVariacao) {
    this.matDialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'Removendo variação',
          bodyMessage:
            this.variacoes.value.length === 1 &&
            this.produtos_variacao.value.length
              ? `Caso remova a variação ${variacao.descricao.toUpperCase()} da lista de selecionadas por ter somente ela na lista todos os produtos variação serão removidos, deseja prosseguir ?`
              : `Deseja remover a variação ${variacao.descricao.toUpperCase()} da lista de selecionadas ?`,
          icon: 'delete',
          icon_color: 'warn'
        },
        width: '400px',
        panelClass: ['custom-container', 'position-relative']
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.changedVariacao = true;
          this.changedVariacoes.emit(false);
          const prevValue = this.variacoes.value;
          const index = prevValue.findIndex(
            x => x.variacao_id === variacao.variacao_id
          );
          if (index >= 0) {
            prevValue.splice(index, 1);
            this.variacoes.setValue(prevValue);
            this.settings.variacoes = this.variacoes.value;
          }

          // if (this.entity.id) this.confirmarVariacao();

          if (this.variacoes.value.length === 0) {
            this.produtos_variacao.setValue([]);
            if (this.entity.id) {
              this.settings.variacoes = [];
              this.clearVariacoes.emit();
              this.updateVariacoesProduto();
            }
          }
        }
      });
  }

  /**
   * Remove um item variação da lista de variações selecionadas
   * @param item_variacao
   */
  removerItemVariacao(item_variacao: IVariacaoItem) {
    const prevValue = this.variacoes.value;
    const index = prevValue.findIndex(
      x => x.variacao_id === item_variacao.variacao_id
    );
    const msg =
      prevValue[index].itens.length === 1
        ? this.variacoes.value.length === 1 &&
          this.produtos_variacao.value.length
          ? `Caso remova a sub-variação ${item_variacao.descricao.toUpperCase()} a variação ${prevValue[
              index
            ].descricao.toUpperCase()} será removida da lista de variações e por só ter ela na lista de selecionadas todos os produtos variação também serão removidos deseja prosseguir ?`
          : `Caso remova a sub-variação ${item_variacao.descricao.toUpperCase()} a variação ${prevValue[
              index
            ].descricao.toUpperCase()} será removida da lista de variações, deseja prosseguir ?`
        : `Deseja remover a sub-variação ${item_variacao.descricao.toUpperCase()} da lista de selecionadas ?`;
    this.matDialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'Removendo sub-variação',
          bodyMessage: msg,
          icon: 'delete',
          icon_color: 'warn'
        },
        width: '400px',
        panelClass: ['custom-container', 'position-relative']
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.changedVariacao = true;
          this.changedVariacoes.emit(false);
          if (index >= 0) {
            const index2 = prevValue[index].itens.findIndex(
              x => x.variacao_item_id === item_variacao.variacao_item_id
            );

            if (index2 >= 0) prevValue[index].itens.splice(index2, 1);

            if (prevValue[index].itens.length === 0) {
              prevValue.splice(index, 1);
            }

            this.variacoes.setValue(prevValue);
            this.settings.variacoes = this.variacoes.value;

            // if (this.entity.id) this.confirmarVariacao();

            if (this.variacoes.value.length === 0) {
              this.produtos_variacao.setValue([]);
              if (this.entity.id) {
                this.settings.variacoes = [];
                this.clearVariacoes.emit();
                this.updateVariacoesProduto();
              }
            }
          }
        }
      });
  }

  /**
   * Limpa a lista de variações
   */
  removerAllVariacao() {
    this.matDialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'Removendo variações',
          bodyMessage: this.produtos_variacao.value.length
            ? `Caso remova todas as variações da lista de selecionadas, ao confirmar todos os produtos variação serão removidos também, deseja prosseguir?`
            : `Deseja remover todas as variações da lista de selecionadas?`,
          icon: 'delete',
          icon_color: 'warn'
        },
        width: '400px',
        panelClass: ['custom-container', 'position-relative']
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.changedVariacao = true;
          this.changedVariacoes.emit(false);
          this.variacoes.setValue([]);
          this.produtos_variacao.setValue([]);
          if (this.entity.id) {
            this.settings.variacoes = [];
            this.clearVariacoes.emit();
            this.updateVariacoesProduto();
          }
        }
      });
  }

  /**
   * Limpa a lista de itens variação de uma variação e remove o pai
   */
  removerAllItemVariacao(variacao: IVariacao) {
    this.matDialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'Removendo sub-variações',
          bodyMessage:
            this.variacoes.value.length === 1 &&
            this.produtos_variacao.value.length
              ? `Caso remova todas as sub-variações da variação ${variacao.descricao.toUpperCase()} ela será removida da lista de variações e por só ter ela na lista todos os produtos variação também serão removido, deseja prosseguir?`
              : `Caso remova todas as sub-variações da variação ${variacao.descricao.toUpperCase()} ela será removida da lista de variações, deseja prosseguir?`,
          icon: 'delete',
          icon_color: 'warn'
        },
        width: '400px',
        panelClass: ['custom-container', 'position-relative']
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.changedVariacao = true;
          this.changedVariacoes.emit(false);
          const prevValue = this.variacoes.value;
          const index = prevValue.findIndex(x => x.variacao_id === variacao.id);
          if (index >= 0) {
            prevValue.splice(index, 1);
            this.variacoes.setValue(prevValue);
          }
          if (this.variacoes.value.length === 0) {
            this.produtos_variacao.setValue([]);
            if (this.entity.id) {
              this.settings.variacoes = [];
              this.clearVariacoes.emit();
              this.updateVariacoesProduto();
            }
          }
        }
      });
  }

  /**
   * Confirma a seleção das variações e gera os produtos variação
   * @param result
   */
  criarProdutosVariacao() {
    this.matDialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'Confirmação de combinação',
          bodyMessage:
            'Confirma a combinação das variações selecionadas para gerar os novos produtos?',
          icon: 'check_circle',
          icon_color: 'primary'
        },
        width: '400px',
        panelClass: ['custom-container', 'position-relative']
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          var settings = { variacoes: [] };
          this.variacoes.value.forEach(variacao => {
            settings.variacoes.push({
              variacao_id: variacao.id ? variacao.id : variacao.variacao_id,
              itens: []
            });
            variacao.itens.forEach(it => {
              settings.variacoes.forEach(v => {
                if (v.variacao_id === it.variacao_id)
                  v.itens.push({
                    variacao_item_id: it.id ? it.id : it.variacao_item_id,
                    variacao_id: v.variacao_id,
                    descricao: it.descricao
                  });
              });
            });
          });
          this.confirmarVariacao(settings);
        }
      });
  }

  /**
   * Remove o produto variação da lista de produtos variação
   * @param produto_variacao
   */
  removerProdutoVariacao(produto_variacao: IProdutoVariacao) {
    this.matDialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'Removendo produto variação',
          bodyMessage: `Deseja remover ${produto_variacao.descricao.toUpperCase()} da lista de selecionados ?`,
          icon: 'delete',
          icon_color: 'warn'
        },
        width: '400px',
        panelClass: ['custom-container', 'position-relative']
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          const prevValue = this.produtos_variacao.value;
          const index = prevValue.findIndex(
            x => x.posicao === produto_variacao.posicao
          );
          if (index >= 0) {
            prevValue.splice(index, 1);
            this.produtos_variacao.setValue(prevValue);
            if (this.entity.id) this.updateVariacoesProduto();
          }
        }
      });
  }

  /**
   * Limpa a lista de produtos variação
   */
  removerAllProdutoVariacao() {
    this.matDialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'Removendo produtos variação',
          bodyMessage: `Deseja remover todos os produtos variação da lista de selecionados?`,
          icon: 'delete',
          icon_color: 'warn'
        },
        width: '400px',
        panelClass: ['custom-container', 'position-relative']
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.produtos_variacao.setValue([]);
          if (this.entity.id) this.updateVariacoesProduto();
        }
      });
  }

  /**
   * Irá gerar pelas variações selecionadas os produtos variação
   * de acordo com a quantidade de combinações possíveis observadas
   * pra cada item de variação selecionada
   */
  confirmarVariacao(settings?) {
    this.entityService
      .gerarProdutosVariacoes(
        settings ? settings.variacoes : this.clearSettingsObj(),
        this.descricao,
        this.entity.id,
        Utils.replaceCommaToDot(this.valor_minimo)
      )
      .subscribe(result => {
        this.changedVariacao = false;
        this.changedVariacoes.emit(true);

        result.variacoes.forEach(it => {
          it.domain_id = this.entity.domain_id;
        });

        this.produtos_variacao.setValue(result.variacoes);
      });
  }

  /**
   * Remove os campos não utilizados pelo backend na geração
   * dos produtos variação
   */
  clearSettingsObj() {
    var retorno_variacoes = this.settings.variacoes;

    retorno_variacoes.forEach(it => {
      it.variacao_id = it.id;
      it.itens.forEach(it2 => {
        it2.variacao_item_id = it2.id;
        it2.variacao_id = it.id;
      });
    });

    retorno_variacoes.forEach(it => {
      it.itens = it.itens.map(j =>
        Utils.onlyAttributes(j, [
          'variacao_item_id',
          'descricao',
          'variacao_id'
        ])
      );
    });

    retorno_variacoes = retorno_variacoes.map(j =>
      Utils.onlyAttributes(j, ['variacao_id', 'itens'])
    );

    return retorno_variacoes;
  }

  /**
   * Aciona uma requisição de PUT no produto passando as variações vazias
   */
  updateVariacoesProduto() {
    var variacoes = this.produtos_variacao.value;
    if (variacoes.length !== 0) {
      variacoes.forEach(it => {
        it.quantidade = Utils.replaceCommaToDot(it.quantidade);
      });
      variacoes = variacoes.map(i =>
        Utils.clearObject(
          Utils.onlyAttributes(i, [
            'produto_id',
            'identificadores',
            'quantidade',
            'sku',
            'id',
            'valor'
          ])
        )
      );
    }
    this.entityService
      .update({
        variacoes: variacoes.length ? variacoes : [],
        id: this.entity.id,
        quantidade: this.entity.id ? this.entity.quantidade : this.quantidade
      } as IProduto)
      .subscribe(
        () => {
          this.matSnackBar.open(
            'Produtos variação atualizados com sucesso!',
            'X',
            {
              panelClass: ['msg-success'],
              horizontalPosition: 'right',
              verticalPosition: 'top',
              duration: 2000
            }
          );
        },
        () => {
          this.produtos_variacao.setValue(
            JSON.parse(localStorage.getItem('PRODUTOS_VARIACAO_BACKUP'))
          );
        }
      );
  }

  varicaoDisplay = (entity: IVariacaoItem): string => {
    if (entity) {
      return entity.variacao.descricao + ' - ' + entity.descricao;
    }
    return '';
  };
}
